import cls from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';
import { MyContext } from '@/config/context-manager';

const experienceConfig = [
  {
    title: '学习体验-板块1-标题',
    description: '学习体验-板块1-描述',
    img: '/images/chinese/experience-card1.png',
    imgEn: '/images/chinese/experience-card1.png',
    imgM: '/images/chinese/learning-card-1-m.png',
    imgMEn: '/images/chinese/learning-card-1-m.png',
    id: 1,
    ga: 'TeacherCTAClick',
    ga4: 'TeacherCTA',
  },
  {
    title: '学习体验-板块2-标题',
    description: '学习体验-板块2-描述',
    img: '/images/chinese/experience-card2.png',
    imgEn: '/images/chinese/experience-card2.png',
    imgM: '/images/chinese/learning-card-2-m.png',
    imgMEn: '/images/chinese/learning-card-2-m.png',
    id: 2,
    ga: 'StudentCTAClick',
    ga4: 'StudentCTA',
  },
  {
    title: '学习体验-板块3-标题',
    description: '学习体验-板块3-描述',
    img: '/images/chinese/experience-card3.png',
    imgEn: '/images/chinese/experience-card3-en.png',
    imgM: '/images/chinese/learning-card-3-m.png',
    imgMEn: '/images/chinese/learning-card-3-m-en.png',
    id: 3,
    ga: 'ScientificCTAClick',
    ga4: 'ScientificCTA',
  },
  {
    title: '学习体验-板块4-标题',
    description: '学习体验-板块4-描述',
    img: '/images/chinese/experience-card4.png',
    imgEn: '/images/chinese/experience-card4-en.png',
    imgM: '/images/chinese/learning-card-4-m.png',
    imgMEn: '/images/chinese/learning-card-4-m-en.png',
    id: 4,
    ga: 'CogniaCTAClick',
    ga4: 'CogniaCTA',
  },
  {
    title: '学习体验-板块5-标题',
    description: '学习体验-板块5-描述',
    img: '/images/chinese/experience-card5.png',
    imgEn: '/images/chinese/experience-card5-en.png',
    imgM: '/images/chinese/learning-card-5-m.png',
    imgMEn: '/images/chinese/learning-card-5-m-en.png',
    imgPCM: '/images/chinese/learning-card-5-pc-m.png',
    imgPCMEn: '/images/chinese/learning-card-5-pc-m-en.png',
    id: 3,
    ga: 'ScientificCTAClick',
    ga4: 'ScientificCTA',
  },
];

const LearningExperience = () => {
  const { t } = useTranslation(['chinese', 'path']);
  const { locale } = useContext(MyContext);
  const isEn = locale === 'en';

  const btnName = (
    <span className="whitespace-nowrap bg-[linear-gradient(89.62deg,#FF1D43_0.3%,#FF3A3A_53.07%,#FF765A_105.88%)] bg-clip-text text-transparent">
      {t('学习体验-按钮')}
    </span>
  );

  return (
    <section className="relative pt-[40px] text-center lg:pb-[58px] lg:pt-[40px] xl:pt-[98px]">
      <div className="container hidden lg:block xl:block">
        <div className=" absolute left-1/2 h-full w-full translate-x-[-50%] lg:top-[-25px] lg:w-[562px] xl:top-[-4px] xl:w-[800px]">
          <Image
            alt="WuKong"
            width={800}
            height={400}
            src="/images/chinese/experience-bg.png"
            quality={100}
          />
        </div>
      </div>
      <div className=" relative z-10">
        <div className="container">
          <Title className="" innerHTML theme="red">
            {`${t('学习体验-标题')}`}
          </Title>
        </div>
        <div className="container mt-11">
          {experienceConfig.map(item => (
            <div
              key={item.title}
              className={cls(
                'mb-[40px] w-[100%] overflow-hidden rounded-[24px] bg-[#fff] shadow-wk1 lg:flex lg:w-[100%] xl:flex xl:w-[100%] xl:rounded-[36px]',
                item.id === 1 || item.id === 3 ? 'flex-row-reverse' : '',
                // isEn && 'lg:h-[285px]',
              )}>
              <div
                className={cls(
                  'block w-[100%] lg:hidden xl:hidden',
                  isEn && 'lg:w-[410px]',
                  item.id === 2 && isEn && '[&]:lg:w-[410px]',
                )}>
                <Image
                  alt={t(item?.title)}
                  className="w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  src={isEn ? item.imgMEn : item.imgM}
                />
              </div>
              <div
                className={cls(
                  'relative mt-[-22px] flex flex-col justify-center rounded-[24px] bg-[#fff] p-[24px] text-left lg:sticky lg:bottom-3 lg:mt-0 lg:w-[516px] xl:sticky xl:bottom-3 xl:mt-0 xl:flex xl:w-[720px] xl:flex-col xl:justify-center xl:p-0',
                  item.id === 1 || item.id === 3
                    ? 'lg:mr-0 xl:mr-0'
                    : 'lg:ml-0 xl:ml-0',
                  isEn
                    ? 'p-[24px] lg:flex-1 lg:p-[0_40px] xl:flex-1 xl:p-[0_60px]'
                    : 'p-[24px] lg:flex-1 lg:p-[0_40px] xl:flex-1 xl:p-[0_60px]',
                )}>
                <h3
                  className={cls(
                    'mb-4 text-lg font-bold leading-normal text-wk-words-1 lg:mb-3 lg:text-[24px] xl:mb-4 xl:text-[28px]',
                    isEn && 'lg:mb-[12px] lg:leading-[28px] [&]:lg:mt-[32px]',
                    (item.id === 2 || item.id === 4) && !isEn && '',
                    (item.id === 3 || item.id === 4) && isEn && '[&&]:lg:mt-0',
                    item.id === 1 && isEn && '[&&&]:lg:mt-0',
                    item.id === 2 && isEn && '[&&&]:lg:mt-0',
                  )}
                  dangerouslySetInnerHTML={{ __html: t(item?.title) }}
                />
                <p
                  className={cls(
                    'mb-5 text-[15px] text-wk-words-2 lg:mb-[20px] lg:text-[16px] lg:leading-[28px] xl:mb-10 xl:text-[18px] xl:leading-[32px]',
                    isEn && 'lg:leading-[24px]',
                  )}
                  dangerouslySetInnerHTML={{ __html: t(item?.description) }}
                />
                <div className="flex items-center justify-center lg:block xl:block">
                  <LeadButton
                    className="flex h-[40px] w-[120px] font-bold lg:h-[44px] lg:w-[144px] lg:text-[16px] xl:h-[48px] xl:w-[192px] xl:text-[18px] [&&]:lg:px-6"
                    subject="chinese"
                    theme="cnBorder"
                    size="base"
                    isBlob={!isEn && item.id === 4}
                    traceName={`O_ChineseCourse_Experience_${item.ga}`}
                    traceGa4Name={`new_entry_ChineseCourse_Experience_${item.ga4}`}>
                    {btnName}
                  </LeadButton>
                </div>
              </div>
              <div
                className={cls(
                  'hidden lg:w-[410px] xl:w-[560px]',
                  isEn && 'lg:w-[410px]',
                  item.id === 2 && isEn && '[&]:lg:w-[410px] [&]:xl:w-[560px]',
                  item.imgPCM ? 'lg:block xl:hidden' : 'lg:block',
                )}>
                <Image
                  alt={t(item?.title)}
                  className="w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  src={
                    isEn ? item.imgPCMEn || item.imgEn : item.imgPCM || item.img
                  }
                />
              </div>
              {item.imgPCM && (
                <div
                  className={cls(
                    'hidden xl:block xl:w-[560px]',
                    isEn && 'lg:w-[410px]',
                    item.id === 2 && isEn && '[&]:xl:w-[560px]',
                  )}>
                  <Image
                    alt={t(item?.title)}
                    className="w-full"
                    height={0}
                    width={0}
                    sizes="100vw"
                    src={isEn ? item.imgEn : item.img}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LearningExperience;
